module.exports = __webpack_public_path__ + "img/communityadminpainpoint5.d3d1a470.png";